import LegalPage, { Section } from "../LegalPage";

function Polityka() {
  return (
    <LegalPage
      tag="Polityka prywatności"
      title="Polityka prywatności i cookie"
      subtitle="Dowiedz się, jak postępujemy z Twoimi danymi osobowymi i dbamy o Twoją prywatność i bezpieczeństwo danych na naszej platformie."
      lastUpdated="01 stycznia 2025 r."
    >
      <Section title="Postanowienia ogólne">
        <h3>Wstęp</h3>
        <p>
          Niniejsza Polityka Prywatności ustanawia zasady ochrony Klientów
          Usługi i Użytkowników KFJ Inwestycje Sp. z o.o. (KFJ) w związku z
          przetwarzaniem Danych Osobowych w trakcie świadczenia usług oraz
          korzystania z Portalu notaup.pl.
        </p>

        <h3>Słownik pojęć użytych w Polityce prywatności</h3>
        <ul>
          <li>
            <strong>Dane Osobowe</strong> – Dane Klientów i Użytkowników
            przetwarzane w związku z korzystaniem z Usługi lub Portalu.
          </li>
          <li>
            <strong>Dane dotyczące aktywności w Portalu lub Usłudze</strong> –
            Historia wyszukiwania, kliknięcia, odwiedziny, dane sesji,
            urządzenia, systemu operacyjnego, przeglądarki, lokalizacji.
          </li>
          <li>
            <strong>Dane rejestracyjne</strong> – Dane podane w formularzach
            rejestracyjnych (imię, nazwisko, NIP, PESEL, adres email itp.)
          </li>
          <li>
            <strong>KFJ</strong> – KFJ Inwestycje Sp. z o.o., ul. 1 Maja 5,
            81-807 Sopot, NIP 5832534157
          </li>
          <li>
            <strong>Portal</strong> – Strony internetowe notaup.pl oraz
            doreczeniaelektroniczne.pl
          </li>
          <li>
            <strong>RODO</strong> – Rozporządzenie (UE) 2016/679 o ochronie
            danych osobowych
          </li>
          <li>
            <strong>Klient</strong> – Podmiot, który aktywował konto na portalu
          </li>
          <li>
            <strong>Użytkownik</strong> – Osoba korzystająca z Portalu
          </li>
        </ul>
      </Section>

      <Section title="Dane kontaktowe KFJ">
        <h3>KFJ jako administrator oraz podmiot przetwarzający</h3>
        <p>
          KFJ przetwarza Dane Osobowe jako administrator w związku z
          korzystaniem z Usługi i Portalu. Czasami KFJ działa również jako
          podmiot przetwarzający dane w imieniu Klienta.
        </p>
        <p>
          <strong>Adres:</strong> KFJ Sp. z o.o., ul. 1 Maja 5, 81-807 Sopot
        </p>
        <p>
          <strong>Adresy email dla kontaktu:</strong>
        </p>
        <ul>
          <li>
            <a href="mailto:iod@doreczeniaelektroniczne.pl">
              iod@doreczeniaelektroniczne.pl
            </a>
          </li>
          <li>
            <a href="mailto:iod@notaup.pl">iod@notaup.pl</a>
          </li>
        </ul>

        <h3>Inspektor Ochrony Danych Osobowych</h3>
        <p>Kontakt poprzez email (adresy wyżej) lub pisemnie na adres KFJ.</p>
      </Section>

      <Section title="Przetwarzanie danych przez KFJ">
        <h3>Dane Osobowe Klientów i Użytkowników i sposób ich przetwarzania</h3>

        <h4>Przetwarzanie w celu korzystania z Usługi lub Portalu</h4>
        <p>
          KFJ przetwarza: Dane rejestracyjne, podane hasło (w postaci
          zaszyfrowanej), Dane zawarte w podpisie kwalifikowanym, Dane podane w
          szczegółach Skrzynki, Dane dotyczące aktywności.
        </p>

        <h4>Przetwarzanie dla uzasadnionych celów biznesowych</h4>
        <ul>
          <li>
            <strong>Dla celów analitycznych:</strong> adres email, dane
            aktywności
          </li>
          <li>
            <strong>Dla celów dochodzenia roszczeń:</strong> dane szczegółów
            Skrzynki, dane korzystania z Usługi
          </li>
          <li>
            <strong>W celu odpowiedzi na zapytania:</strong> dane z wiadomości,
            wniosków, skarg
          </li>
          <li>
            <strong>Badanie satysfakcji:</strong> dane rejestracyjne,
            odpowiedzi na pytania
          </li>
        </ul>

        <h4>Przetwarzanie dla celów marketingowych</h4>
        <p>
          KFJ przetwarza dane podane w szczegółach Skrzynki oraz dane
          aktywności dla tworzenia profilu zgodnego z zainteresowaniami.
          Dostosowana komunikacja marketingowa kierowana jest tylko do tych,
          którzy wyrazili zgodę.
        </p>
        <p>
          <strong>Remarketing:</strong> „wyświetlanie reklam poza Portalem"
          przy użyciu kodów śledzących aktywność użytkowników.
        </p>
      </Section>

      <Section title="Podstawy prawne przetwarzania danych osobowych">
        <h3>W celu świadczenia Usługi</h3>
        <p>
          Dane są „niezbędne do wykonania umowy" (art. 6 ust. 1 lit. b RODO).
        </p>

        <h3>Dla uzasadnionych celów biznesowych</h3>
        <p>
          Podstawa: „prawnie uzasadnione interesy administratora" (art. 6 ust.
          1 lit. f RODO), obejmujące analizę, dochodzenie roszczeń, obsługę
          zapytań, badanie satysfakcji.
        </p>

        <h3>Dla celów marketingowych</h3>
        <p>
          KFJ uważa, że ma „uzasadniony interes prawny" do analizy, ulepszania
          i promocji usług. Klienci wyrażający chęć otrzymywania komunikacji
          działają „w drodze dobrowolnej, świadomej i jednoznacznej zgody".
        </p>
      </Section>

      <Section title="Udostępnianie danych">
        <h3>Podmioty odbierające dane</h3>
        <p>
          KFJ korzysta z dostawców działających jako podmioty przetwarzające,
          świadczące wsparcie, hosting, obsługę klienta, śledzenie incydentów
          bezpieczeństwa, analizę ruchu.
        </p>

        <h3>Kraje odbiorców</h3>
        <p>
          Odbiorcy mają głównie siedzibę w Polsce i Europejskim Obszarze
          Gospodarczym (EOG), niektórzy poza tym terytorium.
        </p>
      </Section>

      <Section title="Prawa Klientów i Użytkowników">
        <p>
          Prawa realizowane poprzez zgłoszenia na:{" "}
          <a href="mailto:iod@doreczeniaelektroniczne.pl">
            iod@doreczeniaelektroniczne.pl
          </a>
        </p>

        <h3>Prawo do wyrażenia oraz cofnięcia zgód</h3>
        <p>
          Wyrażenie zgody jest dobrowolne. Zgody można cofnąć poprzez:
          „kliknięcie rezygnuj z subskrypcji", ustawienia przeglądarki do
          cookies, kontakt z KFJ.
        </p>
        <p>
          „Wycofanie zgody na otrzymywanie komunikacji marketingowej KFJ
          traktuje jako zgłoszenie sprzeciwu wobec profilowania na potrzeby
          marketingowe".
        </p>

        <h3>Prawo dostępu do danych</h3>
        <p>
          Klient ma prawo do informacji czy jego dane są przetwarzane,
          uzyskania informacji o zasadach przetwarzania, dostępu do swoich
          danych i kopii. Pierwsza kopia bezpłatna, kolejne mogą wiązać się z
          opłatą.
        </p>

        <h3>Prawo do sprostowania danych</h3>
        <p>
          Klient może sprostować i uzupełnić swoje dane w ustawieniach
          Skrzynki.
        </p>

        <h3>Prawo do usunięcia danych (prawo do bycia zapomnianym)</h3>
        <p>
          Klient może żądać usunięcia gdy: „przetwarzanie odbywa się z
          naruszeniem prawa", dane nie są niezbędne, cofnięta została zgoda,
          wniesiony sprzeciw wobec marketingu lub statystyk.
        </p>
        <p>
          KFJ zatrzymuje niektóre dane jeśli niezbędne do: wywiązania się z
          obowiązku prawnego, ustalenia, dochodzenia lub obrony roszczeń
          (imię, nazwisko, email, historia użytkownika).
        </p>

        <h3>Prawo do sprzeciwu</h3>
        <p>
          Klient może wnieść sprzeciw wobec wykorzystania danych gdy KFJ
          przetwarza je „w oparciu o prawnie uzasadniony interes". W
          szczególności: prawo do sprzeciwu wobec marketingu bezpośredniego i
          profilowania.
        </p>

        <h3>Prawo do przenoszenia danych</h3>
        <p>
          Prawo do otrzymania danych osobowych „w ustrukturyzowanym,
          powszechnie używanym, nadającym się do odczytu maszynowym formacie" i
          przesłania innemu administratorowi.
        </p>

        <h3>Prawo do złożenia skargi</h3>
        <p>
          <strong>Organ nadzorczy:</strong> Prezes Urzędu Ochrony Danych
          Osobowych
        </p>
        <ul>
          <li>ul. Stawki 2, 00-193 Warszawa</li>
          <li>Tel: 606-950-000 (pn-pt, 10:00-13:00)</li>
          <li>Fax: 22 532 03 01</li>
          <li>
            Email:{" "}
            <a href="mailto:kancelaria@uodo.gov.pl">kancelaria@uodo.gov.pl</a>
          </li>
          <li>Godziny: 8:00-16:00</li>
        </ul>
      </Section>

      <Section title="Przechowywanie danych">
        <h4>Okres przechowywania dla Klientów:</h4>
        <ol>
          <li>Czas realizacji usługi</li>
          <li>
            Okres niezbędny do postępowań reklamacyjnych i dochodzenia roszczeń
          </li>
          <li>Okres przechowywania dowodów przez 36 miesięcy od wystawienia</li>
        </ol>

        <h4>Okres przechowywania dla Użytkowników:</h4>
        <p>Czas cyklu życia cookies na urządzeniu.</p>

        <h4>Okres przechowywania dla subskrybentów:</h4>
        <p>Do czasu rezygnacji z newslettera lub materiałów marketingowych.</p>

        <h4>Po upływie terminów:</h4>
        <p>
          Dane zanonimizowane, z wyjątkiem: imię, nazwisko, email, historia
          użytkownika, informacja o zgodach – przechowywane dla rozpatrywania
          skarg, zgodności podatkowej i obsługi roszczeń.
        </p>
      </Section>

      <Section title="Umowa powierzenia przetwarzania danych">
        <p>
          Klienci w EOG powierzają KFJ przetwarzanie danych na zasadach
          wskazanych w Regulaminie.
        </p>
      </Section>

      <Section title="Przetwarzanie danych dzieci i szczególne kategorie">
        <p>
          KFJ nie przetwarza danych dzieci ani szczególnych kategorii danych.
          Usługa kierowana do osób pełnoletnich (18+). Małoletnich prosimy o
          nieudostępnianie danych osobowych.
        </p>
      </Section>

      <Section title="Ochrona danych osobowych">
        <p>
          KFJ wdrożyło „odpowiednie i skuteczne środki" zapewniające
          bezpieczeństwo. Portal używa „szyfrowanej transmisji danych oraz
          szyfrowanych baz danych" chroniących identyfikację i utrudniających
          nieautoryzowany dostęp.
        </p>
      </Section>

      <Section title="Aktualizacje Polityki prywatności">
        <p>
          KFJ może zmieniać i uzupełniać politykę. O zmianach informuje poprzez
          publikację na stronach Portalu, przy istotnych zmianach wysyła
          odrębne powiadomienia email.
        </p>
        <p>
          Polityka nie ogranicza uprawnień wynikających z Regulaminu i
          przepisów prawa.
        </p>
      </Section>

      <Section title="Polityka Cookies">
        <h3>Czym są cookies?</h3>
        <ul>
          <li>
            Niewielkie pliki tekstowe wysyłane i przechowywane na urządzeniu
          </li>
          <li>
            Pobierane przez przeglądarkę podczas pierwszego wejścia na stronę
          </li>
          <li>Nie powodują zmian konfiguracyjnych urządzenia</li>
          <li>
            Pomagają dostosować zawartość, ułatwiają nawigację, zapewniają
            bezpieczeństwo
          </li>
          <li>Pozwalają ocenić preferencje i jak ulepszać stronę</li>
        </ul>

        <h3>Rodzaje cookies</h3>
        <ol>
          <li>
            <strong>Cookies sesji:</strong> Tymczasowe, pozostają do
            opuszczenia strony, obowiązkowe dla poprawnego działania aplikacji.
          </li>
          <li>
            <strong>Cookies trwałe:</strong> Długotrwałe (zależy od ustawień),
            przekazują informacje przy każdej wizycie, nazywane „ciasteczkami
            śledzącymi".
          </li>
        </ol>

        <h3>Usuwanie i blokada</h3>
        <p>
          Klient/Użytkownik może zmienić sposób użycia cookies przez
          przeglądarkę, w tym zablokować lub usunąć. Proces różni się w
          zależności od przeglądarki – szczegóły w funkcji Pomoc.
        </p>
      </Section>
    </LegalPage>
  );
}

export default Polityka;
